'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var mustache = require('mustache');
var nthBitHeader = require('@narvar/nth-bit-header');
var nthHookTranslations = require('@narvar/nth-hook-translations');
var TextInput = require('@narvar/nth-block-text-input');
var Button = require('@narvar/nth-block-button');
var Box = require('../../../../../../../common/components/layout/Box/Box.js');
var Typography = require('../../../../../../../common/components/Typography.js');
var OTPProvider = require('../OTPProvider.js');
var FormControl = require('../../../../../../../common/components/FormControl.js');
var nthHookTheme = require('@narvar/nth-hook-theme');
var TextLink = require('@narvar/nth-bit-text-link');
var index = require('../../../../../../../common/components/Icon/index.js');
var useTitanAnalytics = require('../../../../../../../common/providers/titan/useTitanAnalytics.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var mustache__default = /*#__PURE__*/_interopDefaultLegacy(mustache);
var TextInput__default = /*#__PURE__*/_interopDefaultLegacy(TextInput);
var Button__default = /*#__PURE__*/_interopDefaultLegacy(Button);
var TextLink__default = /*#__PURE__*/_interopDefaultLegacy(TextLink);

const OTPVerify = () => {
  const titan = useTitanAnalytics["default"]();
  const {
    claimsOtpPhoneVerificationTitle,
    claimsOtpPhoneVerificationCodeSent,
    claimsOtpLast4Formatted,
    claimsOtpPhoneVerificationEnterCodeLabel,
    claimsOtpPhoneVerificationEnterCodeSubmit,
    claimsOtpPhoneVerificationUpdateNumberPrompt,
    claimsOtpPhoneVerificationUpdateNumberAction,
    claimsOtpDidNotReceiveCodeAction,
    claimsOtpDidNotReceiveCodePrompt,
    claimsOtpDidNotReceiveCodeActionSuccess,
    claimsOtpDidNotReceiveCodeActionError,
    claimsOtpInvalidCode,
    claimsOtpSendCodeCoolMessage
  } = nthHookTranslations.useTranslations();
  const {
    captiontextErrorNone,
    linksNoneDefault,
    linksNoneHover
  } = nthHookTheme.useTheme();
  const {
    state: {
      last4Phone,
      maxRequestsReachedForCurrentPhone,
      otpVerifyError,
      otpVerifyLoading,
      otpSendCalled,
      otpSendError,
      otpSendLoading
    },
    otpVerify,
    otpResend,
    handleUpdateNumberNavigateFromVerify
  } = OTPProvider.useOTP();
  const last4PhoneFormatted = mustache__default["default"].render(claimsOtpLast4Formatted ?? '', {
    last4: last4Phone
  });
  const [code, setCode] = React.useState('');
  const submitDisabled = otpVerifyLoading || code.length !== 6;
  const resendSuccess = otpSendCalled && !otpSendLoading && !otpSendError;
  const resendFailure = otpSendCalled && !otpSendLoading && otpSendError;

  // Manages the display of the resend status message
  const [showResendStatus, setShowResendStatus] = React.useState(false);
  const [resendEnabled, setResendEnabled] = React.useState(false);
  const showUpdatePhoneOption = !showResendStatus && maxRequestsReachedForCurrentPhone;
  React.useEffect(() => {
    if (resendSuccess || resendFailure) {
      setShowResendStatus(true);
      setResendEnabled(false);
      setTimeout(() => {
        setShowResendStatus(false);
      }, 3000);
      setTimeout(() => {
        setResendEnabled(true);
      }, 15000);
    }
  }, [resendSuccess, resendFailure]);
  React.useEffect(() => {
    // Note: This effect is only called on first component render
    titan === null || titan === void 0 ? void 0 : titan.page({
      name: 'OTP Verify'
    })
    // eslint-disable-next-line no-console
    .catch(e => console.error(e));
    setTimeout(() => {
      setResendEnabled(true);
    }, 15000);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // The prompt to display when the user was not able to receive a code
  const prompt = showUpdatePhoneOption ? /*#__PURE__*/React__default["default"].createElement(Typography.BodyTextDefault, null, claimsOtpPhoneVerificationUpdateNumberPrompt, ` `, /*#__PURE__*/React__default["default"].createElement(TextLink__default["default"], {
    onClick: handleUpdateNumberNavigateFromVerify,
    linkStyle: {
      sDefault: {
        ...linksNoneDefault,
        fontSize: 'inherit'
      },
      sHover: {
        ...linksNoneHover,
        fontSize: 'inherit'
      }
    }
  }, claimsOtpPhoneVerificationUpdateNumberAction)) : /*#__PURE__*/React__default["default"].createElement(Box["default"], {
    gap: 1
  }, /*#__PURE__*/React__default["default"].createElement(Typography.BodyTextDefault, null, claimsOtpDidNotReceiveCodePrompt), showResendStatus ? /*#__PURE__*/React__default["default"].createElement(Typography.BodyTextDefault, null, resendSuccess && /*#__PURE__*/React__default["default"].createElement(React__default["default"].Fragment, null, /*#__PURE__*/React__default["default"].createElement(index["default"], {
    icon: "CheckMark",
    width: "1em",
    height: "1em"
  }), ` `, claimsOtpDidNotReceiveCodeActionSuccess), resendFailure && /*#__PURE__*/React__default["default"].createElement(React__default["default"].Fragment, null, claimsOtpDidNotReceiveCodeActionError)) : /*#__PURE__*/React__default["default"].createElement(Typography.BodyTextDefault, null, /*#__PURE__*/React__default["default"].createElement(TextLink__default["default"], {
    disabled: !resendEnabled,
    onClick: () => {
      // eslint-disable-next-line no-console
      otpResend().catch(e => console.log(e));
    }
    // We should have some definition in nth-block-text-link for disabled styling. Since we don't,
    // disabled styling is hardcoded here.
    ,
    linkStyle: {
      sDefault: {
        ...linksNoneDefault,
        fontSize: 'inherit',
        ...(!resendEnabled && {
          color: '#808080',
          cursor: 'default',
          textDecoration: 'none'
        })
      },
      sHover: {
        ...linksNoneHover,
        fontSize: 'inherit'
      }
    }
  }, claimsOtpDidNotReceiveCodeAction), !resendEnabled && /*#__PURE__*/React__default["default"].createElement("span", null, ` `, claimsOtpSendCodeCoolMessage)));
  return /*#__PURE__*/React__default["default"].createElement(Box["default"], {
    gap: 4
  }, /*#__PURE__*/React__default["default"].createElement(nthBitHeader.SemibigHeader, {
    as: "h1"
  }, claimsOtpPhoneVerificationTitle), /*#__PURE__*/React__default["default"].createElement(Typography.BodyTextDefault, null, mustache__default["default"].render(claimsOtpPhoneVerificationCodeSent ?? '', {
    phone: last4PhoneFormatted
  })), /*#__PURE__*/React__default["default"].createElement("form", {
    noValidate: true,
    onSubmit: e => {
      e.preventDefault();
      // eslint-disable-next-line no-console
      otpVerify(code).catch(e => console.log(e));
    }
  }, /*#__PURE__*/React__default["default"].createElement(Box["default"], {
    gap: 4
  }, /*#__PURE__*/React__default["default"].createElement(FormControl["default"], {
    error: otpVerifyError,
    helperText: otpVerifyError ? claimsOtpInvalidCode : null
  }, /*#__PURE__*/React__default["default"].createElement(TextInput__default["default"], {
    id: "otpCode",
    type: TextInput.SupportedInputType.text,
    inputMode: "numeric",
    maxLength: 6,
    autoComplete: "one-time-code",
    label: claimsOtpPhoneVerificationEnterCodeLabel || '',
    animateLabel: true,
    value: code,
    onChange: e => setCode(e.target.value)
    // Specifying "error" doesn't give us error styling on the input
    // because "inputtextinputsNoneError" does not appear to be defined
    ,
    error: otpVerifyError,
    containerOverridesStyle: {
      ...(otpVerifyError ? {
        borderColor: (captiontextErrorNone === null || captiontextErrorNone === void 0 ? void 0 : captiontextErrorNone.color) || '#E02020'
      } : undefined)
    }
  })), /*#__PURE__*/React__default["default"].createElement(Button__default["default"], {
    type: Button.ButtonType.submit,
    big: true,
    disabled: submitDisabled
  }, claimsOtpPhoneVerificationEnterCodeSubmit))), /*#__PURE__*/React__default["default"].createElement("div", {
    role: "status"
  }, prompt));
};
var OTPVerify$1 = nthHookTranslations.withTranslationsProvider(nthHookTheme.withThemeProvider(OTPVerify, {
  themeTokens: ['captiontextErrorNone', 'linksNoneDefault', 'linksNoneHover']
}), {
  translationKeys: ['claimsOtpLast4Formatted', 'claimsOtpPhoneVerificationTitle', 'claimsOtpPhoneVerificationCodeSent', 'claimsOtpPhoneVerificationEnterCodeLabel', 'claimsOtpPhoneVerificationEnterCodeSubmit', 'claimsOtpPhoneVerificationUpdateNumberPrompt', 'claimsOtpPhoneVerificationUpdateNumberAction', 'claimsOtpDidNotReceiveCodeAction', 'claimsOtpDidNotReceiveCodePrompt', 'claimsOtpDidNotReceiveCodeActionSuccess', 'claimsOtpDidNotReceiveCodeActionError', 'claimsOtpInvalidCode', 'claimsOtpSendCodeCoolMessage']
});

exports["default"] = OTPVerify$1;
